import { Component, inject, input, model, output } from '@angular/core';
import { ImagesService } from '../services/images.service';
import { AccessService } from '../../core/services/access.service';
import { RoutesService } from '../../shared/services/routes.service';
import { ImageModel } from '../../shared/models/image.model';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { Api } from '../../core/constants/api.constants';
import { ResourceFormCardComponent } from "../../shared/components/resource-form-card/resource-form-card.component";
import { ResourceButtonGroupComponent } from "../../shared/components/resource-button-group/resource-button-group.component";
import { Image, Images } from '../models/image.model';
import { ImagesInterface } from '../interfaces/image.interface';

@Component({
  selector: 'app-images-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonGroupModule,
    ButtonModule,
    TableModule,
    ImageModule,
    ResourceFormCardComponent,
    ResourceButtonGroupComponent
],
  templateUrl: './images-list.component.html',
  styleUrl: './images-list.component.css'
})
export class ImagesListComponent {
  service = inject(ImagesService)
  routesService = inject(RoutesService)

  access = inject(AccessService).access
  url = Api.url.base

  resource = this.service.resource?.toLowerCase();

  detailed = input<boolean>(true);

  value = model<Images>()
  length = output<number>()

  ngOnInit(): void {
    // console.log('Resource: ', this.resource);
    this.service.title.update((value) => 'Lista de Imágenes')
    this.service.get().subscribe(data => { this.value.update(value => {
      value = Image.fromArray(data as ImagesInterface)
      this.length.emit(value.length)
      // console.log('Contract List: ', value)
      return value
    })})
  }
}
